/*
 * A dictionary line with a little markup in it (S48, 2026-10-29).
 *
 * Most of the site's words are plain strings, but a few lines carry emphasis or
 * a piece of code mid-sentence - "matches **any** of the values", "Check the
 * server logs and {ready}." - and the place they sit differs between languages.
 * Splitting such a line into fragments would hand a translator the word order of
 * English; instead the whole sentence is one dictionary entry with three marks a
 * translator can move freely:
 *
 *   **words**   bold (<strong>)
 *   *words*     emphasis (<em>)
 *   {name}      a value the component supplies - usually a <code> element
 *
 * A placeholder with no value is left as written, so a typo shows on the page
 * rather than vanishing.
 */

import { Fragment, type ReactNode } from 'react';

const MARKUP = /(\*\*[^*]+\*\*|\*[^*]+\*|\{\w+\})/;

export function richText(text: string, values: Record<string, ReactNode> = {}): ReactNode {
  return text.split(MARKUP).map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={index}>{part.slice(1, -1)}</em>;
    }
    if (part.startsWith('{') && part.endsWith('}')) {
      const name = part.slice(1, -1);
      if (name in values) return <Fragment key={index}>{values[name]}</Fragment>;
    }
    return part;
  });
}
